import { actionCreatorFactory } from "typescript-fsa";

import { EntityInstancePath } from "@com.mgmtp.a12.kernel/kernel-md-facade";

const factory = actionCreatorFactory("MODULF");

/**
 * Action um aus dem Formular den Textbautein Baum zu öffnen
 */
export const openTextTree = factory<OpenTextTreePayload>("OPEN_TEXT_TREE");

export interface OpenTextTreePayload {
	readonly initiatingActivityId: string;
	readonly repeatableGroupPath: EntityInstancePath;
	readonly fvKey: string;
	readonly kategorie?: string;
	readonly targetFieldName?: string;
}

/**
 * Action um die ausgewählten Textbausteine zu übernehmen und den Baum zu schließen
 */
export const confirmTextTree = factory<ConfirmTextTreePayload>("CONFIRM_TEXT_TREE");

export interface ConfirmTextTreePayload {
	readonly activityId: string;
}

/**
 * Action um einen Antrag zu editieren.
 */
export const editAntragAction = factory<EditAntragActionPayload>("EDIT_ANTRAG");

export interface EditAntragActionPayload {
	readonly activityId: string;
}

export interface RequestEditableActionPayload {
	readonly hasTaskRole?: boolean;
}

/**
 * Action um zu prüfen, ob ein Formular editierbar gemacht werden kann.
 */
export const requestEditableAction = factory<RequestEditableActionPayload>("REQUEST_EDITABLE");

/**
 * Action um die Änderungen im Antrags zu übernehmen.
 */
export const acceptEditAntragAction = factory<AcceptEditAntragActionPayload>("ACCEPT_EDIT_ANTRAG");

export interface AcceptEditAntragActionPayload {
	readonly activityId: string;
}
